import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-active-drivers',
  templateUrl: './active-drivers.component.html',
  styleUrls: ['./active-drivers.component.sass']
})
export class ActiveDriversComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
